export const placeholderForEmpty = '\u2014';

export const emptyValueFormatter = ({ value }) =>
  value != null ? value : placeholderForEmpty;
